import { onDocumentReady, setLocalStorage, getLocalStorage } from "@theme/utilities";

const STORAGE_KEY = "clrty:clinicians-choice-bar-dismissed";
const SESSION_KEY = "clrty:clinicians-choice-bar-dismissed-session";

class ClinciansChoiceBar extends HTMLElement {
  connectedCallback() {
    this.remember = this.dataset.remember || "session";
    this.closeButton = this.querySelector("[data-close]");
    this.reopenButton = this.querySelector("[data-reopen]");

    this.closeButton?.addEventListener("click", this.dismiss.bind(this));
    this.reopenButton?.addEventListener("click", this.show.bind(this));

    onDocumentReady(this.init.bind(this));
  }

  init() {
    if (window.Shopify?.designMode) {
      this.show();
      return;
    }

    if (this.isDismissed()) {
      this.classList.add("clinicians-choice-bar--dismissed");
      return;
    }

    if (window.matchMedia("(max-width: 767px)").matches) {
      this.classList.add("clinicians-choice-bar--dismissed");
      return;
    }

    this.show();
  }

  isDismissed() {
    if (this.remember === "always") return false;
    if (this.remember === "session") {
      return window.sessionStorage?.getItem(SESSION_KEY) === "true";
    }
    return Boolean(getLocalStorage(STORAGE_KEY));
  }

  show() {
    this.classList.remove("clinicians-choice-bar--dismissed");
    this.classList.add("clinicians-choice-bar--visible");
  }

  dismiss() {
    this.classList.remove("clinicians-choice-bar--visible");
    this.classList.add("clinicians-choice-bar--dismissed");

    if (this.remember === "session") {
      window.sessionStorage?.setItem(SESSION_KEY, "true");
    } else if (this.remember !== "always") {
      setLocalStorage(STORAGE_KEY, true, parseFloat(this.remember));
    }
  }
}

if (!customElements.get("clinicians-choice-bar")) {
  customElements.define("clinicians-choice-bar", ClinciansChoiceBar);
}
